'use strict';

angular.module('amexReconciliationApp')
  .service('BcaBillingCyclesRepository', function ($resource) {
    var self = this;

    var bcaSummariesResource = $resource('/api/v1/authenticatedUser/bcaSummaries', {}, {
      getBcas: { method: 'get', isArray: true }
    });

    var billingCyclesResource = $resource('/api/v1/bcaBillingCycles', {}, {
      getBcaBillingCycles: { method: 'get', isArray: true }
    });

    self.get = function () {
      return bcaSummariesResource.getBcas().$promise;
    };

    self.getBillingCycles = function (rca, bca, siteNumber) {
      var params = {rca: rca, bca: bca, siteNumber: siteNumber};
      return billingCyclesResource.getBcaBillingCycles(params).$promise;
    };

  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/BcaBillingCyclesRepository.js
// module id = 603
// module chunks = 0